// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","652":"service","797":"industry"}[chunkId] || chunkId) + "." + {"137":"e126ad85","594":"63feb321","652":"e4aa2339","797":"f38193b9"}[chunkId] + ".css";
};